define('controllers/hotelinfo',['require','controllers/hr'],function(require) {
    'use strict';
    var hr = require('controllers/hr'); 
    return {
        load: function () {
            return hr.load().then(function() {
                $('[data-MarketingPhone]').text(window.ServerData.Phones.MarketingPhone);
                $('#hotelrelationsemail')
                       .attr('href', 'mailto:{0}'.format(window.ServerData.Emails.HotelRelationsEmail))
                       .text(window.ServerData.Emails.HotelRelationsEmail);
            });
        },
        unload: hr.unload
    };
});

